import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Award, Users } from 'lucide-react';
export function Creator() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream-dark/30 relative overflow-hidden" data-id="element-28">
      <div className="dashed-divider absolute top-0 left-0" data-id="element-29" />

      {/* Decorative blobs */}
      <div className="absolute top-1/4 -left-20 w-80 h-80 bg-rose-light/30 rounded-full blur-3xl pointer-events-none" data-id="element-30" />
      <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-caramel-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-31" />

      <div className="max-w-6xl mx-auto relative" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-14 items-center" data-id="element-33">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className="md:col-span-2 relative max-w-sm mx-auto md:mx-0 w-full" data-id="element-34">
            {/* Decorative frame */}
            <div className="absolute -inset-3 bg-gradient-to-br from-caramel/40 via-rose/30 to-caramel/40 rounded-[2rem] blur-xl opacity-70" data-id="element-35" />
            <div className="relative rounded-[1.75rem] overflow-hidden border-4 border-white shadow-2xl" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/uploads/bongmdBzdRcQxQLAEwXHZe/Avatar_Bakery.png" alt="La creadora del manual" className="w-full h-auto object-cover block" data-id="element-37" />
            </div>

            {/* Floating signature badge */}
            <motion.div animate={{
            y: [0, -6, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="absolute -bottom-4 -right-2 bg-white rounded-2xl shadow-xl px-4 py-3 border border-caramel/20 flex items-center gap-2" data-id="element-38">
              <Award className="w-5 h-5 text-caramel" data-id="element-39" />
              <div className="text-left leading-tight" data-id="element-40">
                <div className="text-[10px] uppercase tracking-wider text-espresso-light font-bold" data-id="element-41">
                  Repostera Pro
                </div>
                <div className="text-xs font-serif font-bold text-espresso italic" data-id="element-42">
                  +10 años de experiencia
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="md:col-span-3" data-id="element-43">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-caramel/10 text-caramel-dark font-medium text-sm mb-6 border border-caramel/20" data-id="element-44">
              <Heart className="w-4 h-4" data-id="element-45" />
              Conoce a tu mentora
            </div>

            <h2 className="text-3xl md:text-5xl font-serif font-bold text-espresso leading-[1.15] mb-6" data-id="element-46">
              Hola, soy <span className="italic text-caramel" data-id="element-47">Camila</span>
            </h2>

            <div className="space-y-4 text-espresso-light leading-relaxed text-base md:text-lg" data-id="element-48">
              <p data-id="element-49">
                Hace más de 10 años descubrí que la repostería no solo era mi
                pasión, era mi camino a la libertad financiera. Empecé desde mi
                cocina, sin equipos costosos ni local físico — solo con recetas
                probadas y un método claro.
              </p>
              <p data-id="element-50">
                Hoy he ayudado a{' '}
                <strong className="text-espresso" data-id="element-51">+1,200 mujeres</strong> a
                transformar su talento en un negocio rentable desde casa. Sé
                exactamente qué funciona, qué no, y cuáles son los atajos que
                nadie te cuenta.
              </p>
              <p className="font-serif italic text-espresso text-lg md:text-xl border-l-4 border-caramel pl-4" data-id="element-52">
                "Mi misión es que tú no tardes 10 años en descubrir lo que a mí
                me costó tanto aprender."
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-8" data-id="element-53">
              <div className="text-center md:text-left" data-id="element-54">
                <div className="text-3xl md:text-4xl font-serif font-bold text-caramel" data-id="element-55">
                  +10
                </div>
                <div className="text-xs md:text-sm text-espresso-light font-medium" data-id="element-56">
                  Años de experiencia
                </div>
              </div>
              <div className="text-center md:text-left" data-id="element-57">
                <div className="text-3xl md:text-4xl font-serif font-bold text-caramel" data-id="element-58">
                  +1,200
                </div>
                <div className="text-xs md:text-sm text-espresso-light font-medium" data-id="element-59">
                  Alumnas felices
                </div>
              </div>
              <div className="text-center md:text-left" data-id="element-60">
                <div className="text-3xl md:text-4xl font-serif font-bold text-caramel" data-id="element-61">
                  +50
                </div>
                <div className="text-xs md:text-sm text-espresso-light font-medium" data-id="element-62">
                  Recetas probadas
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}